<template>
  <div class="ApplyForALoan">
    <div class="ApplyForALoan-top">
      <strong>Apply For A Loan</strong>
    </div>

    <div class="ApplyForALoan-body">
      <div class="ApplyForALoan-body-text">
        <strong>Loan Details</strong>
      </div>
      <div class="ApplyForALoan-body-body">
        <div class="ApplyForALoan-body-body-top">
          <div class="ApplyForALoan-body-body-top-text1">
            <strong style="font-weight: 700;font-size:35px">{{ LoanAmount }}₱</strong>
          </div>
          <div class="ApplyForALoan-body-body-top-text2">
            <span>Loan Amount</span>
          </div>
        </div>
        <div class="ApplyForALoan-body-body-body">
          <div class="ApplyForALoan-body-body-body-text">
            <div>
              <span style="font-weight: 700;font-size:20px">{{ Interest }}₱</span>
            </div>
            <div>
              <span>Repayment Interest</span>
            </div>
          </div>
          <div class="ApplyForALoan-body-body-body-text">
            <div>
              <span style="font-weight: 700;font-size:20px">{{ LoanMonth }}</span>
            </div>
            <div>
              <span>Loan Month</span>
            </div>
          </div>
        </div>
        <div class="ApplyForALoan-body-body-foot">
          <div class="ApplyForALoan-body-body-foot-box">
            <strong>Borrower</strong>
            <p style="font-weight: bolder;font-size:15px">{{ Actualname }}</p>
          </div>

          <div class="ApplyForALoan-body-body-foot-box">
            <strong>ID Number</strong>
            <!-- {{ IdNumber }} -->
            <p style="font-weight: bolder;font-size:15px">******</p>
          </div>

          <div class="ApplyForALoan-body-body-foot-box">
            <strong>Bank Name</strong>
            <p style="font-weight: bolder;font-size:15px">{{RepaymentAmount}}</p>
          </div>
          <div class="ApplyForALoan-body-body-foot-box">
            <strong>Bank Card Number</strong>
            <!-- {{ BankCardNumber }} -->
            <p style="font-weight: bolder;font-size:15px">******</p>
          </div>
        </div>
      </div>
    </div>

    <div class="ApplyForALoan-foot">
      <el-button type="submit" @click="Reset" round>Cancel</el-button>
      <el-button type="submit" @click="Submit" round>Submit</el-button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { throttle } from "lodash";
import { watch } from "vue";

export default {
  data() {
    return {
      RepaymentAmount: "",
      Actualname: "",
      IdNumber: "",
      info: false,
      // strong2: "14150000₱",
      LoanAmount: sessionStorage.getItem("LoanAmount"),
      Interest: sessionStorage.getItem("Interest"),
      LoanMonth: sessionStorage.getItem("LoanMonth"),
      BankCardNumber: "",
      apply: {
        blankid: "",
        borrowamount: sessionStorage.getItem("LoanAmount"),
        insuranceamount: sessionStorage.getItem("Interest"),
        term: sessionStorage.getItem("LoanMonth"),
        userid: sessionStorage.getItem("token")
      }
    };
  },
  methods: {
    async getForm() {
      try {
        const a = await axios.get(
          `/borrowingSys/borrowing/borro/isBorrowing?uid=${+sessionStorage.getItem(
            "token"
          )}`
        );
       //console.log(a);
        if (a.data.msg != "可以借款") {
          this.$router.push("/");
        }
      } catch (error) {}
      //真实信息
      try {
        const selectIDCard = await axios.get(
          `/puserSys/puser/selectIDCard?id=${+sessionStorage.getItem("token")}`
        );
        if (selectIDCard.data.code != 401) {
          if (selectIDCard.data.data[0] != null) {
            if (
              selectIDCard.data.data[0].name != "" &&
              selectIDCard.data.data[0].idcard != ""
            ) {
              this.Actualname = selectIDCard.data.data[0].name;
              this.IdNumber = selectIDCard.data.data[0].idcard;
            } else {
              // this.$message.error("Please complete the information");
              this.info = true;
              this.$router.path == "/MyProfileviews"
                ? ""
                : this.$router.push("/MyProfileviews");
              return;
            }
          } else {
            this.info = true;
            // this.$message.error("Please complete the information");
            this.$router.path == "/MyProfileviews"
              ? ""
              : this.$router.push("/MyProfileviews");
            return;
          }
        }
      } catch {}

      //银行卡信息
      try {
        const selectBank = await axios.get(
          `/userbank/userbank/selectBank?uid=${+sessionStorage.getItem(
            "token"
          )}`
        );
        if (
          selectBank.data.data[0].bankcard == "" ||
          selectBank.data.data[0].bankname == null ||
          selectBank.data.data[0].bankname == "" ||
          selectBank.data.data[0].bankcard == null
        ) {
          this.$router.path == "/MyProfileviews"
            ? ""
            : this.$router.push("/MyProfileviews");
          return;
        } else {
          this.BankCardNumber = selectBank.data.data[0].bankcard;
          this.apply.blankid = selectBank.data.data[0].id;
          this.RepaymentAmount = selectBank.data.data[0].bankname;
          ////////console.log(this.apply.blankid)
        }
      } catch {}

      try {
        const selectBank2 = await axios.get(
          `/userbank/userbank/selectBank?uid=${+sessionStorage.getItem(
            "token"
          )}`
        );
        if (selectBank2.data.data.length != 0) {
          if (
            selectBank2.data.data[0].bankcard != "" &&
            selectBank2.data.data[0].bankname != ""
          ) {
            this.apply.blankid = selectBank2.data.data[0].id;
            this.RepaymentAmount = selectBank2.data.data[0].bankname;
          } else {
            this.info = true;
            this.$message.error("Please complete the Bank Account");
            this.$router.path == "/MyProfileviews"
              ? ""
              : this.$router.push("/MyProfileviews");
            return;
          }
        } else {
          this.info = true;
          this.$message.error("Please complete the Bank Account");
          this.$router.path == "/MyProfileviews"
            ? ""
            : this.$router.push("/MyProfileviews");
          return;
        }
      } catch {}

      try {
        const selectIDCard = await axios.get(
          `/puserSys/puser/selectIDCard?id=${+sessionStorage.getItem("token")}`
        );
        if (selectIDCard.data.code != 401) {
          // //////console.log(res);
          if (selectIDCard.data.data[0] != null) {
            if (
              selectIDCard.data.data[0].backidcard != "" &&
              selectIDCard.data.data[0].frontidcard != "" &&
              selectIDCard.data.data[0].holdingidcard != "" &&
              selectIDCard.data.data[0].idcard != "" &&
              selectIDCard.data.data[0].name != ""
            ) {
            } else {
              this.info = true;
              this.$message.error("Please complete the ID Information");
              this.$router.path == "/MyProfileviews"
                ? ""
                : this.$router.push("/MyProfileviews");
              return;
            }
          } else {
            this.info = true;
            this.$message.error("Please complete the ID Information");
            this.$router.path == "/MyProfileviews"
              ? ""
              : this.$router.push("/MyProfileviews");
            return;
          }
        }
      } catch {}

      try {
        const selectInfo = await axios.get(
          `/puserSys/puser/selectInfo?id=${+sessionStorage.getItem("token")}`
        );
        if (selectInfo.data.code != 401) {
          if (selectInfo.data.data[0] != null) {
            if (
              selectInfo.data.data[0].address != "" &&
              selectInfo.data.data[0].educationalbackground != "" &&
              selectInfo.data.data[0].expectedamount != "" &&
              selectInfo.data.data[0].marriage != "" &&
              selectInfo.data.data[0].monthlylncome != "" &&
              selectInfo.data.data[0].purpose != ""
            ) {
            } else {
              this.info = true;
              this.$message.error("Please complete the Information");
              this.$router.path == "/MyProfileviews"
                ? ""
                : this.$router.push("/MyProfileviews");
              return;
            }
            ////////console.log(res);
          } else {
            this.info = true;
            this.$message.error("Please complete the Information");
            this.$router.path == "/MyProfileviews"
              ? ""
              : this.$router.push("/MyProfileviews");
            return;
          }
        }
      } catch {}

      try {
        const selectAutograph = await axios.get(
          `/agreement/agreement/selectAutograph?uid=${+sessionStorage.getItem(
            "token"
          )}`
        );
        if (selectAutograph.data.data.length != 0) {
          if (
            selectAutograph.data.data[0].autograph != "" &&
            selectAutograph.data.data[0].autograph != null
          ) {
          } else {
            this.info = true;
            this.$message.error("Please complete the Signature");
            this.$router.path == "/MyProfileviews"
              ? ""
              : this.$router.push("/MyProfileviews");
            return;
          }
        } else {
          this.info = true;
          this.$message.error("Please complete the Signature");
          this.$router.path == "/MyProfileviews"
            ? ""
            : this.$router.push("/MyProfileviews");
          return;
        }
      } catch {}
    },
    Submit: throttle(function() {
      //   //////console.log( this.apply);
      axios
        .post(`/borrowingSys/borrowing/add`, this.apply)
        .then(res => {
          ////console.log(res);
          if (res.data.code == 200) {
            this.$router.push("/");
            this.$message.success("Apply success");
          }
          if (res.data.code == 500) {
            this.$message.error("Please complete the Information");
            this.$router.path == "/MyProfileviews";
          }
        })
        .catch(() => {});
    }, 3000),
    Reset() {
      this.$router.push("/");
    }
  },
  created() {
    this.getForm();
    ////console.log(1111111);
  },
  mounted() {
    ////////////console.log(1111111);
  },
  watch: {
    // info(newValue, oldValue) {
    //   if (this.info) {
    //     this.$message.error("Please complete the information");
    //   }
    // }
  }
};
</script>

<style scoped>
body {
  margin: 0px;
  padding: 0px;
}

.ApplyForALoan {
  width: 100%;
  height: 700px;
  display: flex;
  flex-direction: column;
  /* border: 1px solid red; */
}

.ApplyForALoan-top {
  width: 100%;
  height: 30px;
  padding-top: 10px;
  color: #333;
  background-color: #ffffff;
  position: fixed;
  top: 0;
  z-index: 1000;
  /* border:1px solid red; */
  border-bottom: 1px solid hwb(180 69% 31%);
}

.ApplyForALoan-body {
  width: 100%;
  height: 60%;
  display: flex;
  flex-direction: column;
  float: left;
  margin-top: 50px;
}

.ApplyForALoan-body-text {
  width: 98%;
  height: 30px;
  text-align: left;
  padding-left: 10px;
  font-size: 25px;
}

.ApplyForALoan-body-body {
  width: 90%;
  height: auto;
  margin-left: 5%;
  margin-top: 3%;
  display: flex;
  flex-direction: column;
  border: 1px solid #ccc;
  /* 添加边框线 */
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
  /* 添加阴影效果 */
  /* border: 2px solid red; */
}

.ApplyForALoan-body-body-top {
  width: 100%;
  height: 20%;
  display: flex;
  flex-direction: column;
  padding-top: 20px;
}

.ApplyForALoan-body-body-top-text1 {
  font-size: 30px;
  color: red;
}

.ApplyForALoan-body-body-top-text2 {
  font-size: 14px;
}

.ApplyForALoan-body-body-body {
  width: 100%;
  height: 15%;
  display: flex;
  justify-content: center;
  margin-top: 30px;
  margin-bottom: 30px;
}

.ApplyForALoan-body-body-body-text {
  width: 50%;
  height: 50px;
  border-right: 1px solid #ccc;
}

.ApplyForALoan-body-body-foot {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.ApplyForALoan-body-body-foot-box {
  width: 100%;
  height: 30%;
  margin-top: 1px;
  display: flex;
  justify-content: space-between;
}

.ApplyForALoan-body-body-foot-box strong {
  color: #a4a9ad;
  margin-left: 5%;
}

.ApplyForALoan-body-body-foot-box p {
  margin-right: 5%;
  margin-top: 1%;
  font-size: 20px;
}

.ApplyForALoan-foot {
  width: 90%;
  height: 50px;
  display: flex;
  justify-content: left;
  margin: 5% 5% 0% 5%;
}

.ApplyForALoan-foot button {
  width: 50%;
  height: 100%;
  border: none;
  color: #ffffff;
  font-size: 18px;
  background-color: #0dbd75;
  /* 默认按钮颜色 */
  transition: background-color 0.3s;
  /* 添加过渡效果 */
}

.ApplyForALoan-foot button:hover {
  background-color: #03d3f3;
  /* 鼠标悬停时按钮颜色 */
}
</style>